import axios from "axios";
const config = require("../config");

class EventCancellation {
    constructor(properties) {
        Object.assign(this, properties);
    }

    static async index(params) {
        const { data } = await axios.get(
            config.api_url + "event-cancellations",
            {
                params,
            },
        );
        return {
            cancellations: data.data.map(
                (cancellation) => new EventCancellation(cancellation),
            ),
            total: data.total,
        };
    }
}

export default EventCancellation;
